import { render, staticRenderFns } from "./BannerDeAmbiente.vue?vue&type=template&id=bea1edb2&"
import script from "./BannerDeAmbiente.vue?vue&type=script&lang=js&"
export * from "./BannerDeAmbiente.vue?vue&type=script&lang=js&"
import style0 from "./BannerDeAmbiente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports